import { createApi } from '@reduxjs/toolkit/query/react';

import { Avatar, Org, SupplierStatusFlags } from '@scaleup/models';
import { baseQuery } from './baseQuery';
import { TagTypes } from './tagTypes';
import { use } from 'react';

export const reportApi = createApi({
  reducerPath: 'report',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getTAOReport: builder.query<{url: string}, void>({
      query: () => ({
        url: `/report/ito`
      })
    }),
    getSRAReport: builder.query<{url: string}, void>({
      query: () => ({
        url: `/report/sra`
      })
    }),
    getSGPReport: builder.query<{url: string}, void>({
      query: () => ({
        url: `/report/sgp`
      })
    }),
  }),
});

export const {
  useGetTAOReportQuery,
  useGetSRAReportQuery,
  useGetSGPReportQuery,
  useLazyGetTAOReportQuery,
  useLazyGetSRAReportQuery,
  useLazyGetSGPReportQuery,
} = reportApi;
